<script>
import AppMenu from './AppMenu';
export default {
    name: 'AppHeader',
    components: { AppMenu },
    computed: {
        menuVisible() {
            return this.$route.path !== '/login' && !this.$route.path.startsWith('/wizard');
        }
    }
};
</script>

<template>
    <div class="header">
        <div class="wrapper">
            <div class="menu">
                <AppMenu v-if="menuVisible"></AppMenu>
            </div>
            <img class="logo" src="../assets/starface_up_logo.png" alt="Logo Starface"/>
        </div>
    </div>
</template>

<style lang="scss" scoped>
@import '../assets/scss/variables.scss';

.header {
    position: fixed;
    height: 72px;
    left: 0;
    top: 0;
    width: 100%;
    background-color: white;
    box-shadow: 0 0 10px 0 $header-shadow;
    z-index: 8;

    .wrapper {
        display: grid;
        display: -ms-grid;
        -ms-grid-columns: 1fr 1fr 1fr;
        grid-template-columns: 1fr 1fr 1fr;
        align-items: center;
        max-width: 1024px;
        margin: auto;
        padding: 20px 24px;

        .menu {
            grid-column: 1 / span 1;
            grid-row: 1;
            -ms-grid-column: 1;
            -ms-grid-row: 1;
            justify-self: start;
            z-index: 8;
        }

        .logo {
            -ms-grid-column: 2;
            grid-column: 2 / span 1;
            grid-row: 1;
            justify-self: center;
            height: 24px;
            width: 208px;
        }
    }
}
</style>
